import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import {
  formatMonetary,
  timeStampToDate,
  formatCPF,
  formatUpperCase,
  formatCNPJ,
} from "../../../../utils/formats";
import { Separator } from "../styles";
import { map, size, toUpper } from "lodash";

const ResumoSection = (props) => {
  const {
    proposalCompleteRegistrationLoading,
    proposalPartnershipRegistrationLoading,
    numeroCpf,
    nomeCliente,
    dataNascimento,
    ufCliente,
    rendaBruta,
    profissao,
    cargo,
    dataAdmissao,
    proposalWarrantyGuarantors,
    proposalWarrantyGuarantorsLoading,
    nomeAnalista,
    descricaoStatus,
    tipoPessoa,
    numeroCnpj,
    razaoSocial,
    nomeFantasia,
    dataFundacao,
    inscricaoEstadual,
    inscricaoMunicipal,
    codigoRamoAtividade,
    descricaoRamoAtividade,
    porteEmpresa,
    codigoCnae,
    descricaoCnae,
    faturamentoAnual,
    rankingRelacionamento,
  } = props;

  return (
    <>
      <Grid container spacing={3}>
        {toUpper(tipoPessoa) === "F" ? (
          <>
            <Grid item xs={4}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="CPF"
                value={formatCPF(numeroCpf)}
              />
            </Grid>
            <Grid item xs={8}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Nome"
                value={formatUpperCase(nomeCliente)}
              />
            </Grid>
            <Grid item xs={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Data nascimento"
                value={timeStampToDate(dataNascimento)}
              />
            </Grid>
            <Grid item xs={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="UF cliente"
                value={formatUpperCase(ufCliente)}
              />
            </Grid>
            <Grid item xs={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Ranking Relacionamento"
                value={formatUpperCase(rankingRelacionamento)}
              />
            </Grid>
            <Grid item xs={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Renda"
                value={formatMonetary(rendaBruta)}
              />
            </Grid>
            <Grid item xs={4}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Profissão"
                value={formatUpperCase(profissao)}
              />
            </Grid>
            <Grid item xs={4}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Cargo"
                value={formatUpperCase(cargo)}
              />
            </Grid>
            <Grid item xs={4}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Data admissão"
                value={timeStampToDate(dataAdmissao)}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={2}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="CNPJ"
                value={formatCNPJ(numeroCnpj)}
              />
            </Grid>
            <Grid item xs={5}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Razão social"
                value={formatUpperCase(razaoSocial)}
              />
            </Grid>
            <Grid item xs={5}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Nome fantasia"
                value={formatUpperCase(nomeFantasia)}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Fundação"
                value={timeStampToDate(dataFundacao)}
              />
            </Grid>
            <Grid item xs={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Inscrição Estadual"
                value={inscricaoEstadual}
              />
            </Grid>
            <Grid item xs={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Inscrição Municipal"
                value={inscricaoMunicipal}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Porte Empresa"
                value={formatUpperCase(porteEmpresa)}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Faturamento Anual"
                value={formatMonetary(faturamentoAnual)}
              />
            </Grid>
            <Grid item xs={4}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Ramo de Atividade"
                value={`${codigoRamoAtividade ?? ""} - ${
                  descricaoRamoAtividade ?? ""
                }`}
              />
            </Grid>
            <Grid item xs={6}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="CNAE"
                value={`${codigoCnae ?? ""} - ${descricaoCnae ?? ""}`}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Ranking Relac."
                value={formatUpperCase(rankingRelacionamento)}
              />
            </Grid>
          </>
        )}
      </Grid>

      {(proposalWarrantyGuarantorsLoading ||
        size(proposalWarrantyGuarantors) > 0) && <Separator />}

      <Grid container spacing={3}>
        {map(
          proposalWarrantyGuarantorsLoading ? [{}] : proposalWarrantyGuarantors,
          (guarantor, index) => {
            const guarantorNumber =
              size(proposalWarrantyGuarantors) > 1 ? index + 1 : "";
            return (
              <>
                <Grid item xs={6} key={"avalista" + index}>
                  <Input
                    loading={proposalWarrantyGuarantorsLoading}
                    label={`Avalista ${guarantorNumber}`}
                    value={formatUpperCase(guarantor.nomeCliente)}
                  />
                </Grid>
                <Grid item xs={6} key={"cpf" + index}>
                  <Input
                    loading={proposalWarrantyGuarantorsLoading}
                    label="CPF"
                    value={formatCPF(guarantor.cpfCnpj)}
                  />
                </Grid>
              </>
            );
          }
        )}
      </Grid>

      <Separator />

      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            label="Analista"
            value={formatUpperCase(nomeAnalista)}
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            loading={proposalCompleteRegistrationLoading}
            label="Status"
            value={formatUpperCase(descricaoStatus)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ResumoSection;
